import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ConsumoFolha } from 'src/app/admihair/api/dto/consumo-folha';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ConsumoFolhaService } from 'src/app/admihair/service/consumo-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-consumo-inserir',
  templateUrl: './consumo-inserir.component.html',
  styleUrls: ['./consumo-inserir.component.scss']
})
export class ConsumoInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;

  profissionais: Profissional[] = [];
  profissionalSelecionado?: Profissional;
  contas: PlanoContaEmpresa[] = [];
  dataRegistro: Date = new Date();
  competencia: Date = new Date();

  mostrarDialogItem: boolean = false;
  listaItens: any[] = [];

  valorCobrarInserido?: number = 0;
  valorTotalCalculado?: number = 0;
  quantidadeItem?: number = 1;
  percentualDesconto: number = 0;
  qtdParcelas: number = 1;

  tipoItemSelecionado: number = 4;
  tiposItem: SelectItem[] = [{ label: 'Serviço', value: 4 }, { label: 'Produto', value: 3 }];
  itemServicoSelecionado?: ItemServico;
  itemProdutoSelecionado?: ItemProduto;
  isItemSelecionado: boolean = false;
  exibirSpinnerDialog: boolean = false;


  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  constructor(private consumoService: ConsumoFolhaService,
    private itemProdutoService: ItemProdutoService,
    private itemServicoService: ItemServicoService,
    private profissionalService: ProfissionalService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CONSUMO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.carregarProfissionais();
    }
  }

  carregarProfissionais() {
    this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionais = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  salvar() {
    this.progressoRequisicao = true;
    const consumo: ConsumoFolha = {
      dataCobranca: this.competencia,
      dataTransacao: this.dataRegistro,
      desconto: this.percentualDesconto,
      parcelas: this.qtdParcelas,
      quantidade: this.quantidadeItem,
      valorACobrar: this.valorCobrarInserido,
      valorTotal: this.valorTotalCalculado,
      itemId: this.obterItemSelecionado()?.id,
      codigoPlanoConta: this.tipoItemSelecionado,
      profissionalId: this.profissionalSelecionado?.id,
      contratoId: this.profissionalSelecionado?.contrato?.id,
      empresaId: this.empresaSelecionada?.id,
      usuarioId: this.utilStorageService.getUser().usuario.id
    };
    console.log(consumo)

    this.consumoService.salvar(consumo).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  obterItemSelecionado() {
    if (this.tipoItemSelecionado === 3) {
      return this.itemProdutoSelecionado;
    } else {
      return this.itemServicoSelecionado;
    }
  }

  adicionarItem(item: any) {
    if (item.planoContaEmpresa.codigo === 4) {
      this.itemServicoSelecionado = item;
      this.valorCobrarInserido = this.itemServicoSelecionado?.valorVenda;
      this.aplicarDesconto();
      this.calcularTotal();
      this.isItemSelecionado = true;
    } else if (item.planoContaEmpresa.codigo === 3) {
      this.itemProdutoSelecionado = item;
      this.valorCobrarInserido = this.itemProdutoSelecionado?.valorVenda;
      this.aplicarDesconto();
      this.calcularTotal();
      this.isItemSelecionado = true;
    }
    this.mostrarDialogItem = false;
  }

  aplicarDesconto() {
    const valorVenda = this.tipoItemSelecionado === 3
      ? this.itemProdutoSelecionado?.valorVenda
      : this.itemServicoSelecionado?.valorVenda;

    if (valorVenda && this.valorCobrarInserido) {
      this.valorCobrarInserido = valorVenda - (valorVenda * (this.percentualDesconto / 100));
      this.calcularTotal();
    }
  }

  calcularTotal() {
    if (this.valorCobrarInserido === 0) {
      this.valorTotalCalculado = 0;
    } else if (this.valorCobrarInserido && this.quantidadeItem) {
      this.valorTotalCalculado = this.valorCobrarInserido * this.quantidadeItem;
    }
  }

  alterarPercentualDesconto() {
    const valorVenda = this.tipoItemSelecionado === 3
      ? this.itemProdutoSelecionado?.valorVenda
      : this.itemServicoSelecionado?.valorVenda;

    if (valorVenda && this.valorCobrarInserido !== null && this.valorCobrarInserido !== undefined) {
      let percentualCalculado;
      if (this.valorCobrarInserido === 0) {
        percentualCalculado = 100;
      } else {
        percentualCalculado = ((valorVenda - this.valorCobrarInserido) / valorVenda) * 100;
      }
      this.percentualDesconto = percentualCalculado < 0 ? 0 : (percentualCalculado > 100 ? 100 : percentualCalculado);
      this.calcularTotal();
    }
  }

  abrirDialogItem() {
    this.carregarItens();
    this.mostrarDialogItem = true;
  }

  carregarItens() {
    this.exibirSpinnerDialog = true;
    const status = true;
    if (this.tipoItemSelecionado === 4) {
      this.itemServicoService.listarPorEmpresaIdESituacao(this.empresaSelecionada?.id, status).subscribe({
        next: (data: ItemServico[]) => {
          this.exibirSpinnerDialog = false;
          this.listaItens = data;
        },
        error: (err: any) => {
          this.exibirSpinnerDialog = false;
          this.exibirMensagemErro(err);
        }
      });
    } else if (this.tipoItemSelecionado === 3) {
      this.itemProdutoService.listarProdutoVendaPorEmpresaId(this.empresaSelecionada?.id).subscribe({
        next: (data: ItemProduto[]) => {
          this.exibirSpinnerDialog = false;
          this.listaItens = data;
        },
        error: (err: any) => {
          this.exibirSpinnerDialog = false;
          this.exibirMensagemErro(err);
        }
      });
    }
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  exibirMensagemSucesso() {
    this.messages = this.erroService.handleSuccess();
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
    this.rolarTela();
  }

  limparFormulario() {
    this.profissionalSelecionado = undefined;
    this.itemProdutoSelecionado = undefined;
    this.itemServicoSelecionado = undefined;
    this.qtdParcelas = 1;
    this.percentualDesconto = 0;
    this.quantidadeItem = 1;
    this.valorTotalCalculado = 0;
    this.valorCobrarInserido = 0;
    this.competencia = new Date();
    this.dataRegistro = new Date();
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
